module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/bz-7826f0d58900985ad3120f3a0b8451dd.svg";